import React from 'react'
import { useParams } from 'react-router-dom'
import { SEOHead } from '../components/ui/SEOHead'
import { AsciiDivider } from '../components/terminal/AsciiDivider'
import { PostList } from '../components/blog/PostList'
import { Pagination } from '../components/ui/Pagination'
import { usePosts } from '../hooks/usePosts'

export const CategoryPage: React.FC = () => {
  const { category } = useParams<{ category: string }>()
  const decodedCategory = category ? decodeURIComponent(category) : ''

  const { posts, loading, totalPages, page, setPage } = usePosts({
    category: decodedCategory,
    pageSize: 10,
  })

  return (
    <>
      <SEOHead
        title={decodedCategory}
        description={`Posts in the ${decodedCategory} category on CodeToByte`}
        url={`/category/${decodedCategory}`}
      />

      <div style={{ paddingTop: '32px' }}>
        <div
          style={{
            fontFamily: "'JetBrains Mono', 'Courier New', monospace",
            fontSize: '0.82rem',
            color: 'var(--text-secondary)',
            marginBottom: '4px',
          }}
        >
          category:
        </div>
        <div
          style={{
            fontFamily: "'JetBrains Mono', 'Courier New', monospace",
            fontSize: '1.2rem',
            color: 'var(--accent-cyan)',
            marginBottom: '8px',
          }}
        >
          {decodedCategory}
        </div>

        <AsciiDivider label={decodedCategory.toUpperCase()} width={60} />

        <PostList
          posts={posts}
          loading={loading}
          emptyMessage={`No posts found in category "${decodedCategory}".`}
        />

        <Pagination
          currentPage={page}
          totalPages={totalPages}
          onPageChange={(p) => {
            setPage(p)
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }}
        />
      </div>
    </>
  )
}
